<div class="main-container no-select">
    <div class="scaleRaterType">
        <div class="left-panel">
            <app-active-filters-chips></app-active-filters-chips>
        </div>
        <app-add-filters-button [isAddfilterBtnEnabled]="true" [isUniversalFilterEnabled]="true" [isHuddleFilterEnabled]="false"></app-add-filters-button>
    </div>
    
</div>
<div class="main-container no-select">
    <div class="ltms-tabs">
        <!-- <span class="ltms-tab" (click)="onClickingNavigation('summary')" [ngClass]="{'ltms-active-tab': activeTab ==='summary' || !activeTab}">Summary</span> -->
        <span class="ltms-tab" *ngIf="tabVisisblity.overview" (click)="onClickingNavigation('overview')" [ngClass]="{'ltms-active-tab': activeTab === 'overview'}">Overview</span>
        <span class="ltms-tab" *ngIf="tabVisisblity.trends && isTrendsTabShow" (click)="onClickingNavigation('trends')" [ngClass]="{'ltms-active-tab': activeTab === 'trends' || !activeTab}">Trends</span>
        <span class="ltms-tab"  *ngIf="tabVisisblity.details" (click)="onClickingNavigation('details')" [ngClass]="{'ltms-active-tab': activeTab === 'details'}">Details</span>
        <!-- <div class="customLine"></div> -->
    </div>
    <div class="main-discription">
        <span class="ltms-description">{{ mainDiscription }}</span>
        <div class="scalerRaterTypeBox">
            <app-score-comparison-toggle
                *ngIf="activeTab === 'overview' && tabVisisblity.overview"
                [visible]="isOverviewComparisonAvailable()"
                [showComparisonFlag]="overviewShowComparison"
                [dateType]="getOverviewDateType()"
                [checkboxId]="'scoreOverviewComparisonCheckbox'"
                (showComparisonChange)="onOverviewShowComparisonChange($event)">
            </app-score-comparison-toggle>
            <div class="scaleRaterText">Scale selector</div>
            <app-score-dropdown-menu [config]="scaleSelectorConfig" [selectedOption]="scaleRaterType['selectedOption']" [options]="scaleRaterType.options" (selectedOptionChange)="onOptionChange($event)"></app-score-dropdown-menu>
        </div>
    </div>
    <div *ngIf="queryParams$ | async as params">
        <!-- <div *ngIf="activeTab === 'summary' || !activeTab">
            <app-score-summary></app-score-summary>
        </div> -->
        <div *ngIf="(activeTab === 'trends' || !activeTab) && tabVisisblity.trends && isTrendsTabShow">
            <app-score-trends></app-score-trends>
        </div>
        <div *ngIf="activeTab === 'details' && tabVisisblity.details">
            <app-score-details></app-score-details>
        </div>
        <div *ngIf="activeTab === 'overview' && tabVisisblity.overview">
            <app-score-overview [(showComparisonFlag)]="overviewShowComparison"></app-score-overview>
        </div>
    </div>
</div>